import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';

import { translate } from '../../commons/localize';

import InfoHeader from './InfoHeader';
import AuxiliarManager from './AuxiliarManager';
import CombinedDatesForm from '../CombinedDatesForm';
import GroupSelector from '../GroupSelector';
import SelectorTextArea from '../SelectorTextArea';
import InfoAmount from './InfoAmount';
import ButtonsManager from './ButtonsManager';

import { showNotification } from '../../commons/utils';

const EditionMode = (props) => {
  const {
    defaultLang,
    reservation,
    datesLimits,
    firstValorate,
    preventButtonActions,
    readOnly,
    specificDataComponent,
    tabsDataComponent
  } = props;

  const {
    id,
    status,
    locator,
    fromDate,
    toDate,
    amount,
    currencyCode,
    comment,
    valorated,
    modified
  } = reservation;

  const customProps = (firstValorate) ? { isVisible: valorated } : {};

  const cancellationAction = () => {
    props.handleCancellation(
      reservation,
      (errorMessage) => {
        props.modalManager('errorModal', 'errorCancelarReserva', errorMessage, 'entendido');
      },
      () => {
        showNotification('seHaCanceladoReserva', 'exitoCancelacionReserva', [locator]);
      }
    );
  };

  const handleReservationDates = (fromDate, toDate) => {
    props.handleDates(id, fromDate, toDate);
  };

  const handleReservationComment = (comment) => {
    props.handleComment(id, comment);
  };

  const handleReservationCreation = () => {
    props.handleCreation(
      reservation,
      (errorMessage) => {
        props.modalManager('errorModal', 'errorCrearReserva', errorMessage, 'entendido');
      }
    );
  };

  const handleReservationElimination = () => {
    props.handleElimination(id);
  };

  const handleReservationUndoChanges = () => {
    props.handleUndoChanges(id);
  };

  const handleReservationModification = () => {
    props.handleModification(
      reservation,
      (errorMessage) => {
        props.modalManager('errorModal', 'errorModificarReserva', errorMessage, 'entendido');
      }
    );
  };

  const handleReservationCancellation = () => {
    props.modalManager(
      'atencionModal',
      'confirmarCancelacion',
      undefined,
      'continuar',
      cancellationAction,
      true,
      'volver'
    );
  };

  return (
    <>
      <Row className="auto-margin">
        <Col sm="11" className="info-header custom-padd" data-test-id="cabecera-reserva">
          <InfoHeader
            locator={locator}
            identifier={id}
            status={status}
            modified={modified}
            valorated={valorated}
          />
        </Col>
        <Col sm="1" className="no-padding-right reservation-icon-gest text-right">
          <AuxiliarManager
            readOnly={readOnly}
            existingReservation={(locator !== '')}
            isModified={modified}
            handleRevertDataAction={handleReservationUndoChanges}
            handleDeleteAction={handleReservationElimination}
          />
        </Col>
      </Row>
      <Row className="auto-margin">
        <Col sm="5">
          <CombinedDatesForm
            titleFrom={translate('fechaEntrada')}
            titleTo={translate('fechaSalida')}
            titleNights={translate('noches')}
            defaultLang={defaultLang}
            defaultFromDate={fromDate}
            defaultToDate={toDate}
            minDefaultDate={datesLimits.minDate}
            maxDefaultDate={datesLimits.maxDate}
            handleDatesData={handleReservationDates}
            readOnly={readOnly}
          />
        </Col>
        <Col sm="7">
          {specificDataComponent}
        </Col>
      </Row>
      <Row className="auto-margin">
        <Col sm="12">
          {tabsDataComponent}
        </Col>
      </Row>
      <Row className="auto-margin">
        <GroupSelector
          reservationId={id}
          reservationGroup={reservation.groupId}
        />
        <Col sm="8">
          <SelectorTextArea
            name="comment"
            title={translate('comment')}
            placeHolder={translate('escribaComentario')}
            dataTestLabel="comentario-reserva"
            defaultValue={comment}
            onBlurEvent={handleReservationComment}
            maxLength="2000"
            readOnly={readOnly}
          />
        </Col>
        <InfoAmount
          {...customProps}
          amount={amount}
          currencyCode={currencyCode}
          colSize={4}
        />
      </Row>
      <ButtonsManager
        status={status}
        valorated={valorated}
        modified={modified}
        hasToValorate={firstValorate}
        readOnly={readOnly}
        isDisabled={preventButtonActions}
        cancellationAction={handleReservationCancellation}
        valorationAction={props.handleAppraise}
        modificationAction={handleReservationModification}
        creationAction={handleReservationCreation}
      />
    </>
  );
};

EditionMode.propTypes = {
  defaultLang: PropTypes.string,
  reservation: PropTypes.object.isRequired,
  datesLimits: PropTypes.shape({
    minDate: PropTypes.string,
    maxDate: PropTypes.string
  }),
  firstValorate: PropTypes.bool,
  preventButtonActions: PropTypes.bool,
  readOnly: PropTypes.bool,
  specificDataComponent: PropTypes.node,
  tabsDataComponent: PropTypes.node,
  handleDates: PropTypes.func,
  handleComment: PropTypes.func,
  handleCreation: PropTypes.func,
  handleModification: PropTypes.func,
  handleUndoChanges: PropTypes.func,
  handleElimination: PropTypes.func,
  handleCancellation: PropTypes.func,
  handleAppraise: PropTypes.func,
  modalManager: PropTypes.func
};

EditionMode.defaultProps = {
  defaultLang: 'es',
  datesLimits: {
    minDate: undefined,
    maxDate: undefined
  },
  firstValorate: false,
  preventButtonActions: false,
  readOnly: false,
  specificDataComponent: <></>,
  tabsDataComponent: <></>,
  handleDates: () => {},
  handleComment: () => {},
  handleCreation: () => {},
  handleModification: () => {},
  handleUndoChanges: () => {},
  handleElimination: () => {},
  handleCancellation: () => {},
  handleAppraise: () => {},
  modalManager: () => {}
};

export default EditionMode;
